<template>
	<div>
		<div class="first_line">
			<div class="right_warp">
				<el-select class="jul" size="small" filterable v-model="filter.storeId" style="margin-right:3px;"
					placeholder="请选择">
					<el-option v-for="item in statelist" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-date-picker v-model="filter.time" @change="getlist()" type="daterange" size="small"
					style="margin-left: 10px;margin-right: 25px; width: 250px;" value-format="yyyy-MM-dd"
					range-separator="至">
				</el-date-picker>
				<el-button class="jul" type="primary" @click="getlist" size="small">筛选</el-button>
			</div>
			<div>
				<el-button class="jul" type="primary" @click="exports" size="medium">导出</el-button>
			</div>
		</div>
		<div>
			<div class="calendar">
				<el-table :data="list" style="width: 100%"
					:header-cell-style="{background:'#F2F2F4', 'text-align':'center'}"
					:cell-style="{'text-align':'center'}">
					<el-table-column prop="applyDate" label="申请时间"></el-table-column>
					<el-table-column prop="workerName" label="姓名"></el-table-column>
					<el-table-column prop="storeName" label="门店"></el-table-column>
					<el-table-column prop="type" label="申请类型">
						<template slot-scope="scope">
							{{ scope.row.type | typeFormat }}
						</template>
					</el-table-column>
					<el-table-column prop="beginDate" label="开始时间">
						<template slot-scope="scope">
							{{ scope.row.beginDate ?scope.row.beginDate :'/' }}
						</template>
					</el-table-column>
					<el-table-column prop="endDate" label="结束时间">
						<template slot-scope="scope">
							{{ scope.row.endDate ?scope.row.endDate :'/' }}
						</template>
					</el-table-column>
					<el-table-column label="时长">
						<span slot-scope="scope" v-if="scope.row.days>=1">
							{{ scope.row.days}}
						</span>
						<span slot-scope="scope" v-else>
							{{scope.row.half |typeFormat1 }}
						</span>
					</el-table-column>
					<el-table-column prop="reason" label="事由"></el-table-column>
					<el-table-column prop="status" label="状态">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.status == 1" class="go">审核通过</el-tag>
							<el-tag v-else-if="scope.row.status == 2" class="refuse">审核驳回</el-tag>
							<el-tag v-else="scope.row.status == 0" class="wait">待审核</el-tag>
						</template>
					</el-table-column>
					<el-table-column align="center" label="操作" width="85" fixed="right">
						<template slot-scope="scope" v-if="scope.row.status == 0">
							<el-button type="text" size="small" class="green" @click="edit(scope.row.id,1)">通过
							</el-button>
							<el-button type="text" size="small" class="red" @click="edit(scope.row.id,2)">驳回</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagechange">
			<el-pagination :current-page="filter.pageNum" :page-sizes="[10,20,50]" :page-size="filter.pageSize"
				@size-change="handleSizeChange" @current-change="handleCurrentChange"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
	</div>
</template>
<script>
	import {
		parseTime,
		url
	} from "../../../utils/index.js"
	import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
	export default {
		components: {
			ElImageViewer
		},
		data() {
			return {
				url: url(),
				total: 0,
				list: [],
				//后续删name:1
				name: 1,
				dates: [],
				filter: {
					time: [(new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) < 10 ? '0' + (new Date()
							.getMonth() + 1) : (new Date().getMonth() + 1)) + '-' + '01'),
						(new Date().getFullYear() + '-' + ((new Date().getMonth() + 2) < 10 ? '0' + (new Date()
							.getMonth() + 2) : (new Date().getMonth() + 2)) + '-' + '01')
					],
					pageNum: 1,
					pageSize: 10,
					storeName: undefined,
				},
				showViewer: false,
				times: "",
				timeVal: "",
				storeval: [],
				statelist: [{
					value: undefined,
					label: "全部门店"
				}],
			};
		},
		mounted() {
			this.getstorelist();
			this.getlist();
		},
		filters: {
			typeFormat(val) {
				switch (val) {
					case 0:
						return "事假";
					case 1:
						return "病假";
					case 2:
						return "年假";
					case 3:
						return "产假";
					case 4:
						return "陪产假";
					case 5:
						return "婚假";
					case 6:
						return "丧假";
					default:
						return "/";
				}
			},
			typeFormat1(val) {
				switch (val) {
					case 0:
						return "上半天";
					case 1:
						return "下半天";
					default:
						return "/";
				}
			}
		},
		methods: {
			//考勤列表导出
			exports() {
				var urls = this.url + "dWorkerApply/exportDWorkerApply?startTime=" + this.filter.time[0] + "&endTime=" +
					this.filter.time[1];
				if (this.filter.storeId) urls += "&storeId=" + this.filter.storeId;
				window.location.assign(urls)
			},
			edit(id, status) {
				var a = {
					id: id,
					status: status
				}
				console.log(a)
				this.$http.post("dWorkerApply/save", JSON.stringify(a)).then((res) => {
					if (res.body.code == "200") {
						this.getlist()
					}
				})
			},
			getlist() {
				var a = {
					// storeName: this.filter.storeName,
					// month: this.filter.month,
					storeId: this.filter.storeId,
					startTime: this.filter.time[0],
					endTime: this.filter.time[1],
					page: this.filter.pageNum,
					size: this.filter.pageSize,
				}
				this.$http.get("dWorkerApply/findWorkerApply", {
					params: a
				}, {
					emulateJSON: true
				}).then((res) => {
					if (res.body.code == 200) {
						this.list = res.body.data
						this.total = res.body.total
					}
					console.log(res)
				})
				// this.filter.pageNum=1
			},
			getstorelist() {
				this.$http.get("store/list").then((res) => {
					if (res.body.code == 200) {
						res.body.data.forEach(ele => {
							if (ele.businessType == 0) this.statelist.push({
								value: ele.id,
								label: ele.title
							})
						});
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			onPreview() {
				this.showViewer = true
			},
			closeViewer() {
				this.showViewer = false
			},
			handleSizeChange(val) {
				console.log(val)
				this.filter.pageSize = val
				this.getlist()
			},
			handleCurrentChange(val) {
				console.log(val)
				this.filter.pageNum = val
				this.getlist()
			},
		},
	};
</script>
<style lang="less" scoped>
	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.green {
		color: green;
	}

	.red {
		color: red;
	}

	.none {
		visibility: hidden;
	}

	.wait {
		background-color: #b9def8;
		color: #0f8bad;
		border: 0;
	}

	.go {
		background-color: #bff8b9;
		color: #4cc341;
		border: 0;
	}

	.refuse {
		background-color: #f8b9b9;
		color: #c34646;
		border: 0;
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.pagechange {
		margin-top: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
</style>